import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { About } from './routes/about/About';
import { Home } from './routes/Home';
import { Pricing } from './routes/pricing/Pricing';
import { Privacy } from './routes/Privacy';
import { Refunds } from './routes/Refunds';
import { Terms } from './routes/Terms';
import { NotFound } from './routes/NotFound';
import { PageviewTracker } from './PageviewTracker';
import { initClientTelemetry } from './telemetry';
import { persistSharedKnockKnockCookie } from './knockKnock';
import './index.css';

initClientTelemetry();
persistSharedKnockKnockCookie(
  window.location.hostname,
  document.cookie,
  (value) => {
    document.cookie = value;
  },
);

const router = createBrowserRouter([
  {
    element: <PageviewTracker />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/pricing', element: <Pricing /> },
      { path: '/about', element: <About /> },
      { path: '/privacy', element: <Privacy /> },
      { path: '/terms', element: <Terms /> },
      { path: '/refunds', element: <Refunds /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
